import { MONTHS_OPTIONS } from "../../../../../components/inputs/consts";

type ResultsDisplayHeaderProps = {
  monthIndex: number;
  year: number;
};

export const ResultsDisplayHeader = ({
  monthIndex,
  year,
}: ResultsDisplayHeaderProps) => {
  return (
    <section className="w-full my-4 text-center">
      <h3 className="text-2xl">
        Validation for {MONTHS_OPTIONS.find((m) => m.code === monthIndex).name}{" "}
        {year}
      </h3>
    </section>
  );
};
